export default __webpack_public_path__ + "static/media/progress_indicator.ed44c911.svg";